/**
 * Dashboard - CountryInfo Store
 *
 * @since 2018-07-30
 * @author ms1124.kim
 *
 */
import JSONBigInt from 'json-bigint'

const analysisApiPath = '/api/an'
const analysisDataApiPath = `${analysisApiPath}/analysis`
const analysisPanelList = '/api/au/static/analysis-widgets'

export const state = () => ({
  profile: {},
  panelList: {},
  profileList: []
})

export const mutations = {
  /*
    이름: addProfileList
    설명: 프로파일 목록을 스토어에 초기화한다.
  */
  addProfileList (state, {init = false, profiles = []}) {
    if (init) {
      state.profileList = profiles
    } else {
      state.profileList.push(profiles)
    }
  },
  /*
    이름: setProfile
    설명: 선택된 프로파일의 내부 데이터를 스토어에 적용한다.
  */
  setProfile (state, newProfile) {
    state.profile = newProfile
  },
  /*
    이름: modProfile
    설명: 수정된 프로파일 데이터를 스토어에 적용한다.
  */
  modProfile (state, {id, layout}) {
    // 프로파일 ID 검색
    const modIdx = state.profileList.findIndex(profile => profile.id === Number(id))

    // 프로파일 이름 수정
    state.profileList[modIdx].title = layout.title

    // 프로파일 데이터 수정
    state.profile.col = layout.col
    state.profile.topn = layout.topn
    state.profile.title = layout.title
    state.profile.charts = layout.charts
  },
  /*
    이름: delProfile
    설명: 스토어를 삭제하고 Profile 정보를 초기화한다.
  */
  delProfile (state, {id}) {
    // 프로파일 제거
    state.profile = {}
    state.profileList = state.profileList.filter(profile => profile.id !== Number(id))
  },
  /*
    이름: initProfile
    설명: 스토어를 초기화한다.
  */
  initProfile (state) {
    state.profile = {}
    state.panelList = {}
    state.profileList = []
  },
  /*
    이름: setAnalysisPanelList
    설명: 스토어에 분석 패널 템플릿 목록을 초기화한다
  */
  setAnalysisPanelList (state, panelList = []) {
    state.panelList = panelList
  }
}
export const actions = {
  /*
    이름: getAnalysisProfileList
    설명: 서버에 저장된 분석 프로파일 목록을 불러오고 스토어에 저장한다.
  */
  async getAnalysisProfileList ({commit, state}, {type}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$get(`${analysisApiPath}/${type}/profiles`, {
        loading: false,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = result
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: getAnalysisProfile
    설명: 아이디에 해당되는 프로파일을 전달한다.
  */
  async getAnalysisProfile ({commit, state}, {id, type}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$get(`${analysisApiPath}/${type}/profiles/${id}`, void 0, {
        loading: true,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = result
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: addAnalysisProfile
    설명: 프로파일을 추가한다.
  */
  async addAnalysisProfile ({commit, dispatch}, {type, profile}) {
    const res = {
      code: 'ok'
    }

    try {
      // 0. 프로파일 추가 API 호출
      const {code, result} = await this.$axios.$post(`${analysisApiPath}/${type}/profiles`, profile, {
        loading: false,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = result
      }
      if (code !== 'ok') {
        return { code, reason: result.msg }
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: modAnalysisProfile
    설명: 프로파일을 수정한다.
  */
  async modAnalysisProfile ({dispatch}, {id, type, profile}) {
    const res = {
      code: 'ok'
    }

    try {
      const {code, result} = await this.$axios.$put(`${analysisApiPath}/${type}/profiles/${id}`, profile, {
        loading: false,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = result
      }
      if (code !== 'ok') {
        return {code, reason: result.msg}
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: delAnalysisProfile
    설명: 프로파일을 삭제한다.
  */
  async delAnalysisProfile ({dispatch}, {id, type}) {
    const res = {
      code: 'ok'
    }

    try {
      await this.$axios.$delete(`${analysisApiPath}/${type}/profiles/${id}`, void 0, {
        loading: true,
        successAlert: false
      })
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: applyAnalysisProfile
    설명: 분석 프로파일 변동사항을 DB에 적용한다.
  */
  async applyAnalysisProfile () {
    const res = {
      code: 'ok'
    }

    try {
      const {code} = await this.$axios.$put(`${analysisApiPath}/command/analysis/apply`, void 0, {
        loading: false,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = true
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: cancelAnalysisProfile
    설명: 마지막에 적용된 변동사항을 취소한다.
  */
  async cancelAnalysisProfile () {
    const res = {
      code: 'ok'
    }

    try {
      const {code} = await this.$axios.$put(`${analysisApiPath}/command/analysis/cancel`, void 0, {
        loading: false,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = true
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /*
    이름: startAnalysisData
    설명: 분석 데이터 조회를 시작한다.
  */
  async startAnalysisData ({commit, state}, analysisParams) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$post(`${analysisDataApiPath}/start`, analysisParams, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisStatus
    설명: 조회중인 분석 데이터의 상태를 가져온다.
  */
  async getAnalysisStatus ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisDataApiPath}/${requestId}/status`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisData
    설명: 분석이 중지 / 완료된 데이터를 가져온다.
  */
  async getAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$get(`${analysisDataApiPath}/${requestId}/result`, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: stopAnalysisData
    설명: 조회중인 작업을 중지하고 현재까지의 결과를 리턴한다.
  */
  async stopAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisDataApiPath}/${requestId}${'/stop'}`, {
        loading: false,
        successAlert: false,
        transformResponse: [
          (data) => {
            return JSONBigInt.parse(data)
          }
        ]
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: endAnalysisData
    설명: 조회 작업이 완료되면 호출된다. 서버의 리소스를 해제하는 명령어이므로 반드시 호출한다.
  */
  async endAnalysisData ({commit, state}, {requestId}) {
    let result = {
      code: 'ok',
      result: {}
    }

    try {
      result = await this.$axios.$delete(`${analysisDataApiPath}/${requestId}${'/end'}`, {
        loading: false,
        successAlert: false
      })
    } catch (e) {
      result.code = 'nok'
      result.reason = e
    }

    return result
  },
  /*
    이름: getAnalysisPanelList
    설명: 분석에서 사용하는 내부 컨텐츠 패널 리스트를 서버로부터 불러온다.
  */
  async getAnalysisPanelList ({state, commit}) {
    const res = {
      code: 'ok'
    }

    if (state.panelList.length > 0) {
      return res
    }

    try {
      const {code, result} = await this.$axios.$get(`${analysisPanelList}`, {
        loading: false,
        successAlert: false
      })

      if (code === 'ok') {
        res.result = result
        commit('setAnalysisPanelList', result)
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
export const getters = {}
export const strict = false
